<template>
  <div class="searchContent">
    <div class="bgContent">
      <a-carousel autoplay>
        <div v-for="(item, index) in getSets(navTabList)" :key="index">
          <a-list :data-source="item.childs">
            <a-list-item slot="renderItem" slot-scope="item">
              <div class="special-card">
                <div class="img-box">
                  <img :src="item.iconUrl" style="width: 100%; height: 100%" />
                </div>
              </div>
            </a-list-item>
          </a-list>
        </div>
      </a-carousel>
      <div class="homeBtnClass">
        <div class="freeBtnClass">免费创作</div>
        <div class="seeMoreClass">
          <div class="seeMoreIconClass"></div>
          <span style="margin-top: 10px; color: #ccc">滑动查看更多</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getqueryKeywordRanking } from '@/api/home'
export default {
  data() {
    return {
      tabType: 'componentLibrary',
      searchList: [],
      hotSearchList: [],
      historyFlag: false,
      activeIndex: 0,
      keyword: '',
      navTabList: [
        {
          iconUrl: require('@/assets/banner/banner1.png'),
          id: 1,
        },
      ],
    }
  },
  created() {
    document.addEventListener('click', (e) => {
      if (this.$refs.showPanel && this.$refs.showHistoryPanel) {
        let isSelf = this.$refs.showPanel.contains(e.target)
        let isHistorySelf = this.$refs.showHistoryPanel.contains(e.target)
        if (!isSelf && !isHistorySelf) {
          this.historyFlag = false
        }
      }
    })
    // this.getqueryKeywordRanking()
  },
  methods: {
    /**
     * 查询用户搜索关键词热度排行
     */
    getqueryKeywordRanking() {
      getqueryKeywordRanking()
        .then((res) => {
          if (res.status == 0) {
            this.hotSearchList = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((res) => {
          this.$message.error(res.message)
        })
    },
    changeDate(list) {
      if (list.length > 10) {
        return list.slice(0, 10)
      } else {
        return list
      }
    },
    clearSearchHistory() {
      localStorage.removeItem('searchList')
      this.searchList = []
    },
    searchClick() {
      if (localStorage.getItem('searchList')) {
        const result = localStorage.getItem('searchList')
        this.searchList = result ? JSON.parse(result).reverse() : []
      }

      this.historyFlag = true
    },
    blurSearch() {
      this.historyFlag = false
    },
    tabChange() {
      this.$emit('tabChange', this.tabType)
    },
    //文件图片样式
    errorImg(item) {
      if ((item.iconUrl ?? '') === '') {
        return require('@/assets/img/atlas.png')
      } else {
        return this.jointPath(item.iconUrl)
      }
    },
    getSets(list) {
      let newArr = []
      for (let i = 0; i < list?.length;) {
        let obj = {}
        obj.childs = list?.slice(i, (i += 1))
        newArr.push(obj)
      }
      return newArr
    },
    onSearch() {
      console.log(this.keyword.length)
      if (this.keyword.length > 50) {
        this.$message.error('搜索的关键字不要超过50个')
      } else {
        let result = localStorage.getItem('searchList') ? JSON.parse(localStorage.getItem('searchList')) : []
        let obj = {
          name: this.keyword,
        }

        if (this.keyword) {
          result.push(obj)
        }

        localStorage.setItem('searchList', JSON.stringify(result))

        this.historyFlag = false
        this.$emit('onSearch', this.keyword)
      }
    },
    skipSearchPage(keyword) {
      this.$emit('onSearch', keyword)
    },
    clear() {
      this.keyword = ''
      if (!this.isHome) {
        this.$emit('onSearch', this.keyword)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.searchContent {
  width: 100%;
  height: 100vh;
  position: relative;

  /deep/ .ant-list-item {
    padding: 0px;
  }

  .bgContent {
    width: 100%;
    position: relative;

    .special-card {
      width: 100%;
      height: 100vh;

      .img-box {
        width: 100%;
        height: 100vh;
      }
    }

    .homeBtnClass {
      position: absolute;
      bottom: 20%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .freeBtnClass {
        width: 88px;
        height: 32px;
        background: linear-gradient(270deg, #d9a8ff 0%, #0166fc 100%);
        border-radius: 35px 35px 35px 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
      }

      .seeMoreClass {
        margin-top: 50px;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;

        .seeMoreIconClass {
          width: 40px;
          height: 40px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          background-image: url('./../../assets/images/seeMoreIcon.png');
        }
      }
    }
  }

  .titleBox {
    width: 100%;
    height: 166px;
    position: absolute;
    left: 0px;
    top: 110px;
    text-align: center;

    .titleBanner {
      height: 69px;
      font-size: 48px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #1d2129;
    }

    .titleText {
      margin-top: 8px;
      font-size: 20px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #4e5969;
    }
  }
}

/deep/ .ant-input:focus {
  box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
}

/deep/ .ant-carousel .slick-dots {
  height: 25px;
}

/deep/ .ant-carousel .slick-dots {
  height: 25px;
}
</style>
